export default __webpack_public_path__ + "static/media/new-badge.0fc3c61f.svg";